import { Grid2 as Grid, Grid2Props as GridProps, styled } from '@mui/material'
import { TimeInput } from 'components/InputMask'
import React, { useEffect, useState } from 'react'

interface TimePickerProps {
  onChange?: (minutes: string) => void
  onEnter?: () => void
  minutes?: string
  size?: GridProps['size']
}

const StyledInput = styled(TimeInput)(() => ({
  width: '50px',
  textAlign: 'center'
}))

const TimePicker: React.FC<TimePickerProps> = ({
  onChange,
  onEnter,
  size,
  minutes: minuteProp
}) => {
  const [hours, setHours] = useState<string>('')
  const [minutes, setMinutes] = useState<string>('')

  useEffect(() => {
    const result = Number(hours) * 60 + Number(minutes)
    if (onChange) onChange(result.toString())
  }, [hours, minutes])

  const hoursInProp = Math.floor(Number(minuteProp) / 60)
  const minutesInProp = Number(minuteProp) - hoursInProp * 60

  useEffect(() => {
    if (hoursInProp != Number(hours) || minutesInProp != Number(minutes)) {
      setHours(hoursInProp.toString().padStart(2, '0'))
      setMinutes(minutesInProp.toString().padStart(2, '0'))
    }
  }, [minuteProp])

  const handleKeyDown: React.KeyboardEventHandler<HTMLDivElement> = event => {
    if (event.key == 'Enter') {
      if (onEnter) onEnter()
    }
  }

  return (
    <Grid
      container
      spacing={1}
      flexDirection={'row'}
      alignItems={'center'}
      justifyContent={'center'}
      size={size}
    >
      <StyledInput
        onKeyDown={handleKeyDown}
        value={hours}
        onChange={setHours}
        type='hours'
      ></StyledInput>
      :
      <StyledInput
        onKeyDown={handleKeyDown}
        value={minutes}
        onChange={setMinutes}
      ></StyledInput>
    </Grid>
  )
}

export default TimePicker
